import React, { useState } from "react";
import {
  Breadcrumb,
  PageHeader,
  ListingHeader,
  ModalComponent,
  AntSelect,
  InputType,
  SweetAlert,
  ActionWrapper,
  TablePlus,
  Toggle,
} from "../../../../../../components";
import { Link } from "react-router-dom";
import {
  Columns,
  getCountryService,
} from "../../../../../../services/index.service";
import { modalNotification } from "../../../../../../utils";

function ListCountry(props) {
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const onConfirmAlert = () => {
    setIsAlertVisible(false);
    modalNotification({ type: "success", message: "Country Deleted Successfully", })
    return true;
  };
  function onAction(e, handler){
    e.preventDefault();
    handler()
  }
  const actionFormatter = (options) => {
    return (
      <ActionWrapper>
        {options.map((item, key) => {
          return (
            <li onClick={(e)=>onAction(e, item.handler)} key={key} className="action_list">
              <Link to="#">
                <em className={item.icon} />
                {item.name}
              </Link>
            </li>
          );
        })}
      </ActionWrapper>
    );
  };

  const columns = Columns.countryTableColumn({
    Action: () =>
      actionFormatter([
        {
          name: "Edit",
          icon: "icon ni ni-edit",
          handler:editcountryActionFilterShow,
        },
        {
          name: "Delete",
          icon: "icon ni ni-trash",
          handler:()=>{ setIsAlertVisible(true);
            document.body.click()}
        },
      ]),
  });

  const customerData = getCountryService();

  const breadcrumb = [
    {
      path: "/admin/dashboard",
      name: "Dashboard",
      
    },
    {
      path: "#",
      name: "Country",
    },
  ];
  const [countryActionFilter, setCountryActionFilter] = useState(false);
  const countryActionFilterShow = () => {
    setCountryActionFilter(true);
  };
  const countryActionFilterHide = () => {
    setCountryActionFilter(false);
  };
  const [editcountryActionFilter, seteditCountryActionFilter] = useState(false);
  const editcountryActionFilterShow = () => {
    seteditCountryActionFilter(true);
  };
  const editcountryActionFilterHide = () => {
    seteditCountryActionFilter(false);
  };
  const unitData = [
    {
      id: "1",
      name: "KMs",
    },
    {
      id: "2",
      name: "Miles",
    },
  ];
  const statusData = [
    {
      id: "1",
      name: "Active",
    },
    {
      id: "2",
      name: "Inactive",
    },
  ];
  const statusActionOption = [
    {
      id: 1,
        name: 'Select Action'
      },
      {
        id: 2,
        name: 'Make Active'
      },
      {
        id: 3,
        name: 'Make Inactive'
      },
      {
        id: 4,
        name: 'Make Delete'
      }
  ]
  return (
    <>
      <div className="nk-block-head nk-block-head-sm">
        <div className="nk-block-between">
          <PageHeader heading="Country">
            <Breadcrumb breadcrumb={breadcrumb} />
          </PageHeader>
          <ListingHeader
            btnArray={[ "create", "csvExport"]}
            btnText="Add Country"
            onHandleShow={countryActionFilterShow}
          />
        </div>
      </div>
      {/* <DataTable
        hasLimit
        noOfPage="1"
        sizePerPage="10"
        page="1"
        count="100"
        tableData={customerData}
        tableColumns={columns}
        selectRow
        // param={param}
        // defaultSort={defaultSort}
        setSizePerPage=""
        // tableLoader={tableLoader}
        // tableReset={tableReset}
        // getSearchValue={getSearchValue}
        // searchPlaceholder={t("text.search.manageCustomers")}
      /> */}
      <TablePlus
        hasLimit
        noOfPage="1"
        sizePerPage="10"
        page="1"
        count="100"
        tableData={customerData}
        tableColumns={columns}
        isSearch={false}
        showAction={false}
        statusAction
        statusActionOption={statusActionOption}
        
        // tableLoader={isLoading}
        setSizePerPage=""
        selectRow={true}
      />
      <SweetAlert
        title="Are you sure"
        text="you want to delete this country"
        show={isAlertVisible}
        icon="warning"
        showCancelButton
        confirmButtonText="Yes"
        cancelButtonText="No"
        setIsAlertVisible={setIsAlertVisible}
        // showLoaderOnConfirm
        // loading={loading}
        onConfirmAlert={onConfirmAlert}
      />
      <div className="card mt-3">
        <div className="card-inner">
          <div className="bq-note">
            <div className="bq-note-text">
              <div className="nk-block-head nk-block-head-sm nk-block-between">
                <h5 className="title">Notes:</h5>
              </div>
              <ul className="list list-sm list-checked">
                <li>Country module will list all countries on this page.</li>
                <li>
                  Administrator can Activate / Deactivate / Delete any country.
                </li>
                <li>Administrator can export data in XLS or PDF format.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <ModalComponent
        backdrop
        show={countryActionFilter}
        onHandleCancel={countryActionFilterHide}
        title="Add Country"
      >
        <form>
          <div className="row g-3">
            <div className="col-md-6">
              <div className="form-group ">
                <label className="form-label">
                  Country Name <span className="text-danger"> *</span>
                </label>
                <InputType
                  className="form-control"
                  placeholder="Enter country name"
                  name="CountryName"
                  type="text"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group ">
                <label className="form-label">
                  Country Code <span className="text-danger"> *</span>
                </label>
                <InputType
                  className="form-control"
                  placeholder="Enter country code"
                  name="CountryCode"
                  type="text"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group ">
                <label className="form-label">
                  Country Phone Code <span className="text-danger"> *</span>
                </label>
                <InputType
                  className="form-control"
                  placeholder="Enter country phone code"
                  name="CountryPhoneCode"
                  type="text"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group ">
                <label className="form-label">
                  Unit <span className="text-danger"> *</span>
                </label>
                <AntSelect
                  size="medium"
                  id="status"
                  extraClassName="form-control"
                  name="statusId"
                  disabled={false}
                  variant="standard"
                  placeholder="Enter unit"
                  options={unitData}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group ">
                <label className="form-label">
                  Emergency Number <span className="text-danger"> *</span>
                </label>
                <InputType
                  className="form-control"
                  placeholder="Enter emergency number"
                  name="emergencynumber"
                  type="text"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group ">
                <label className="form-label">
                  Cgst (IN %)
                </label>
                <InputType
                  className="form-control"
                  placeholder="Enter tax"
                  name="tax"
                  type="text"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group ">
                <label className="form-label">
                  Status
                </label>
                <Toggle />
              </div>
            </div>
            <div className="col-md-12 text-end">
              <Link
                href="#"
                onClick={() => countryActionFilterHide()}
                className="btn btn-primary me-2"
              >
                Add
              </Link>
              <Link
                href="#"
                className="btn btn-light me-2"
              >
                Reset
              </Link>
              <Link
                href="#"
                onClick={() => countryActionFilterHide()}
                className="btn btn-secondary"
              >
                Cancel
              </Link>
            </div>
          </div>
        </form>
      </ModalComponent>
      <ModalComponent
        backdrop
        show={editcountryActionFilter}
        onHandleCancel={editcountryActionFilterHide}
        title="Edit Country"
      >
        <form>
          <div className="row g-3">
            <div className="col-md-6">
              <div className="form-group ">
                <label className="form-label">
                  Country Name <span className="text-danger"> *</span>
                </label>
                <InputType
                  className="form-control"
                  placeholder="Enter country name"
                  name=" CountryName"
                  type="text"
                  defaultValue="Albania"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group ">
                <label className="form-label">
                  Country Code <span className="text-danger"> *</span>
                </label>
                <InputType
                  className="form-control"
                  placeholder="Enter country code"
                  name=" CountryCode"
                  type="text"
                  defaultValue="355"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group ">
                <label className="form-label">
                  Country Phone Code <span className="text-danger"> *</span>
                </label>
                <InputType
                  className="form-control"
                  placeholder="Enter country phone code"
                  name="CountryPhoneCode"
                  type="text"
                  defaultValue="+1"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group ">
                <label className="form-label">
                  Unit <span className="text-danger"> *</span>
                </label>
                <AntSelect
                  size="medium"
                  id="status"
                  extraClassName="form-control"
                  name="statusId"
                  disabled={false}
                  variant="standard"
                  placeholder="Enter unit"
                  options={unitData}
                  defaultValue="KMs"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group ">
                <label className="form-label">
                  Emergency Number <span className="text-danger"> *</span>
                </label>
                <InputType
                  className="form-control"
                  placeholder="Enter emergency number"
                  name="Emergencynumber"
                  type="text"
                  defaultValue="+12345678"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group ">
                <label className="form-label">
                  Cgst (IN %)
                </label>
                <InputType
                  className="form-control"
                  placeholder="Enter tax"
                  name="tax"
                  type="text"
                  defaultValue="5"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group ">
                <label className="form-label">
                  Status
                </label>
                 <Toggle />
              </div>
            </div>
            <div className="col-md-12 text-end">
              <Link
                href="#"
                onClick={() => editcountryActionFilterHide()}
                className="btn btn-primary me-1 me-sm-2"
              >
                Update
              </Link>
              <Link
                href="#"
                className="btn btn-light me-1 me-sm-2"
              >
                Reset
              </Link>
              <Link
                href="#"
                onClick={() => editcountryActionFilterHide()}
                className="btn btn-secondary"
              >
                Cancel
              </Link>
            </div>
          </div>
        </form>
      </ModalComponent>
    </>
  );
}

export default ListCountry;
